export const QuizData = [
    {
        question: "Which Month Comes after December?",
        options:[ "May", "April", "January", "February"],
        answer: 3
    },
    {
        question: "What is the area of circle?",
        options:["pi*r", "pi*r*r", "2*pi*r", "3*pi*r"],
        answer: 2
    },
    {
        question: "What does HTML stand for?",
        options: ["Hypertext Markup Language", "Hypertext Markdown Language", "Hyperloop Machine Language", "Helicopters Terminals Motorboats Lamborginis"],
        answer: 1
    },
    {
        question: "When do we celebrate republic day?",
        options: ["26th January", "15th January", "26th August", "none of the above"],
        answer:1
    },
];
